import {
  addDays,
  formatJstDateTimeHm,
  jstWallClockToInstant,
} from '~/models/dateTime'

/**
 * 提出後のスポット約定との食い違いのバナー本文 (AC-PPP-020)。1 文目は共通で、
 * 2 文目だけが表示した時点の時刻で変わる。`submitFrom` は `{{submitFrom}}` に入れる
 * 対象日の前日 17:00 (JST、`yyyy/MM/dd HH:mm`)。
 */
export type SpotTradeResultMismatchBody =
  | {
      key: 'page:planSubmission.spotTradeResultMismatch.bodySubmitFrom'
      submitFrom: string
    }
  | { key: 'page:planSubmission.spotTradeResultMismatch.bodyRecreateAndSubmit' }

/**
 * バナー本文を選ぶ。`now` が対象日の前日 12:00 以上 17:00 未満 (JST) なら前日 17:00 以降の
 * 提出を案内し、それ以外 (対象日が無い時を含む) は作り直して提出するよう案内する。OCCTO は前日 12:00〜17:00 に
 * 翌日計画も当日計画も受け付けない (spec AC-PPP-020、OCCTO FAQ 7-1)。
 *
 * @param targetDate 計画の対象日 (カレンダー日)。無ければ undefined
 * @param now 表示した時点 (絶対時刻)。表示後の時刻の進みでは選び直さない
 */
export function resolveSpotTradeResultMismatchBody(
  targetDate: Date | undefined,
  now: Date,
): SpotTradeResultMismatchBody {
  if (targetDate === undefined) {
    return {
      key: 'page:planSubmission.spotTradeResultMismatch.bodyRecreateAndSubmit',
    }
  }
  const previousDay = addDays(targetDate, -1)
  const windowStart = jstWallClockToInstant(previousDay, 12, 0)
  const windowEnd = jstWallClockToInstant(previousDay, 17, 0)
  if (now >= windowStart && now < windowEnd) {
    return {
      key: 'page:planSubmission.spotTradeResultMismatch.bodySubmitFrom',
      submitFrom: formatJstDateTimeHm(windowEnd),
    }
  }
  return {
    key: 'page:planSubmission.spotTradeResultMismatch.bodyRecreateAndSubmit',
  }
}
